export default {
  map_unavailable: 'No se pudo cargar el mapa. Recarga la página para intentarlo de nuevo.',
  stubs: {
    name: 'Zona de entrega {{number}}',
  },
  buttons: {
    add_new_zone: 'Añadir nueva zona',
  },
  toasts: {
    failed_to_load_data: 'Error al cargar las zonas de entrega',
  },
};
